import React from "react";
import * as helmetPkg from "@dr.pogodin/react-helmet";
const { Helmet, HelmetProvider } = helmetPkg;
const RedwoodProvider = ({
  children,
  titleTemplate
}) => {
  const appTitle = globalThis.__REDWOOD__APP_TITLE;
  const template = () => {
    if (titleTemplate) {
      let template2 = titleTemplate.replace(/%AppTitle/g, appTitle);
      template2 = template2.replace(/%PageTitle/g, "%s");
      return template2;
    }
    return "";
  };
  if (RWJS_ENV.RWJS_EXP_STREAMING_SSR) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(HelmetProvider, { context: globalThis.__REDWOOD__HELMET_CONTEXT }, /* @__PURE__ */ React.createElement(Helmet, { titleTemplate: template(), defaultTitle: appTitle }, /* @__PURE__ */ React.createElement("title", null, appTitle)), children);
};
export {
  RedwoodProvider
};
